import React from 'react';
import { injectIntl } from 'react-intl';
import { inject, observer } from 'mobx-react';
import ReactJoyride from 'react-joyride';

@injectIntl
@inject('rootStore')
@observer
class MainTooltips extends React.Component {
  constructor(props) {
    super(props);

    const { tooltipStore } = props.rootStore;

    this.el = document.getElementById('igheader-tooltip-button');

    tooltipStore.setMountFunc(this.mountFunc);
  }

  mountFunc = () => {
    if (this.el) this.el.onclick = this.onClick;
  };

  componentWillMount() {
    this.mountFunc();
  }

  componentWillUnmount() {
    if (this.el) this.el.onclick = null;
  }

  onClick = e => {
    const { tooltipStore } = this.props.rootStore;

    e.preventDefault();

    tooltipStore.takeTour();
  };

  render() {
    const { rootStore, customJoyrideProps } = this.props;
    const { joyrideProps } = rootStore.tooltipStore;

    return <ReactJoyride {...{ ...joyrideProps, ...customJoyrideProps }} />;
  }
}

export default MainTooltips;
